import { RetailProductProperties, TaxonomyItemPatientWeightProperties } from "modules/TaxonomyModule/consts";
import { RETAIL_PRODUCT_RELATION } from "modules/TaxonomyModule/consts/TaxonomyClassRelationsNames";

export const retailProductPropsKeys = Object.values({
  ...RetailProductProperties,
  ...TaxonomyItemPatientWeightProperties,
});

export const retailProductRelationsKeys = [
  RETAIL_PRODUCT_RELATION.TO_FLAVOR,
  RETAIL_PRODUCT_RELATION.TO_PACK_COLOR,
];
